import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const loadScriptOnce = (id, src, innerHTML) => {
    if (document.getElementById(id)) return;

    const script = document.createElement("script");
    script.id = id;

    if (src) {
        script.async = true;
        script.src = src;
    }

    if (innerHTML) script.innerHTML = innerHTML;

    document.head.appendChild(script);
};

const GTMManager = () => {
    const location = useLocation();

    /* -----------------------------------------
       1️⃣ LOAD GTM ONLY ON FIRST MOUNT
    ------------------------------------------ */
    useEffect(() => {
        const initialPath = window.location.pathname;

        const gtmId = initialPath.startsWith("/homeverse")
            ? "GTM-WJN86G5T" // Behtar Broker GTM
            : "GTM-W8KHZLZ";  // Global GTM

        if (!document.getElementById("gtm-base")) {
            const script = document.createElement("script");
            script.id = "gtm-base";
            script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
            document.head.appendChild(script);
        }
    }, []);

    /* -----------------------------------------
       2️⃣ PUSH PAGEVIEW ON ROUTE CHANGE
    ------------------------------------------ */
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            pagePath: location.pathname,
        });
    }, [location.pathname]);

    /* -----------------------------------------
       3️⃣ CONDITIONAL PIXELS (BehtarBroker)
    ------------------------------------------ */
    useEffect(() => {
        const path = location.pathname;

        if (path.startsWith("/homeverse")) {
            // Google Ads
            loadScriptOnce(
                "google-ads-base",
                "https://www.googletagmanager.com/gtag/js?id=AW-16868353483"
            );

            loadScriptOnce(
                "google-ads-config",
                null,
                `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16868353483');
        `
            );

            // Meta Pixel
            loadScriptOnce(
                "meta-pixel",
                null,
                `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}
        (window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '648092974793548');
        fbq('track', 'PageView');
        `
            );
        } else {
            // Clean Behtar-only scripts when leaving
            [
                "google-ads-base",
                "google-ads-config",
                "meta-pixel",
            ].forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.remove();
            });
        }
    }, [location.pathname]);

    /* -----------------------------------------
       4️⃣ LINKEDIN PIXEL (job_apply pages)
    ------------------------------------------ */
    useEffect(() => {
        const path = location.pathname;

        if (path.includes("job_apply")) {
            loadScriptOnce(
                "linkedin-insight-base",
                null,
                `
        _linkedin_partner_id = "8419716";
        window._linkedin_data_partner_ids =
          window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        `
            );

            loadScriptOnce(
                "linkedin-insight-lib",
                "https://snap.licdn.com/li.lms-analytics/insight.min.js"
            );
        } else {
            ["linkedin-insight-base", "linkedin-insight-lib"].forEach((id) => {
                const el = document.getElementById(id);
                if (el) el.remove();
            });
        }
    }, [location.pathname]);

    /* -----------------------------------------
     5️⃣ APPLY NOW THANK YOU CONVERSION
  ------------------------------------------ */
    useEffect(() => {
        const path = location.pathname;


        if (path.includes("landing/apply-now/thank-you")) {
            loadScriptOnce(
                "apply-now-google-ads",
                "https://www.googletagmanager.com/gtag/js?id=AW-18188130622"
            );

            loadScriptOnce(
                "apply-now-google-ads-config",
                null,
                `
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function(){
            dataLayer.push(arguments);
        };

        window.gtag('js', new Date());
        window.gtag('config', 'AW-18188130622');
        `
            );

            setTimeout(() => {
                window.gtag?.('event', 'conversion', {
                    send_to: 'AW-18188130622/IFdgCIu0nsQcEL6y4-BD',
                    value: 1.0,
                    currency: 'INR'
                });
            }, 1000);
        }
    }, []);

    return null;
};

export default GTMManager;

